<template>
  <div class="lefttab_wrap">
    <div class="title clear">
      <img :src="info.imgUrl" class="fl img" />
      <div class="text">
        <span>{{ info.text }}</span>
        <p class="egtext">{{ info.egText }}</p>
      </div>
    </div>
    <div v-if="info.tabList">
      <el-tabs v-model="aboutTab" class="tab_wrap3" tab-position="left" @tab-click="handleClick">
        <el-tab-pane v-for="(item, index) in info.tabList" :key="index" :label="item.Name" :name="item.Id"></el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  data() {
    return {
      aboutTab: ''
    }
  },
  props: {
    info: {
      type: Object
    }
  },
  computed: {
    tabList() {
      return this.info.tabList
    }
  },
  watch: {
    tabList(newval) {
      if (newval.length > 0) {
        this.aboutTab = newval[0].Id
      }
    }
  },
  mounted() {
    var that = this
  },
  methods: {
    handleClick(tab, event) {
      this.$emit('switchCon', tab.name)
    }
  }
}
</script>
<style scoped lang="scss">
.lefttab_wrap {
  width: 260px;
  margin-right: 25px;
  display: inline-block;
  .title {
    width: 220px;
    background: #0774c5;
    color: #fff;
    padding: 40px 20px;
    .text {
      position: relative;
      display: inline-block;
      font-size: 28px;
      padding-left: 40px;
      .egtext {
        color: #00ccf6;
        font-size: 18px;
        margin-top: 2px;
      }
    }
    .text:after {
      position: absolute;
      clear: both;
      content: '';
      width: 1px;
      height: 40px;
      display: block;
      left: 19px;
      top: 0;
      background: #fff;
    }
  }
}
</style>
